<template>
    <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <keep-alive>
          <DataTableMainServer
            :datatable="table"
            :on-success="SuccessTableAction"
            :itemsAction="SuccessTableAction"
            :Updatepagination="params"
            :on-pagination="pagePagination"
            :on-search="getSearchPagePagination"
          />
          <ViewDetails :object="object" type="DetailEquipo" />
          <Breadcrumb v-if="showTree" :items="breadcrumb" />
        </keep-alive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'
import Breadcrumb from '@/components/Arbol/Breadcrumb'

export default {
  mixins: [Permission],
  props: {
    espacio: {
      type: Object,
      required: true
    },
    deportes: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    openDialog: false,
    showTree: true,
    table: {
      modelMain: [],
      showSelect: false,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'deporte.entry' }
        ],
        titles: [
          { text: 'Nombre del deporte', value: 'descripcion.deporte.nombre', class: 'black--text' },
          { text: 'Responsable', value: 'descripcion.responsable.NombreCompleto', class: 'black--text' },
          { text: 'Telefono', value: 'descripcion.responsable.caracteristicas.telefono', class: 'black--text' },
          { text: 'activo', value: 'activo', class: 'black--text' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Ver Ligas', icon: 'mdi-crown', color: 'blue', action: 'toLigas', code: 'next.liga' },
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'toUpdate', code: 'deporte.entry' },
          { title: 'Agregar Integrante', icon: 'mdi-account-plus', color: 'success', action: 'newEncargado', code: 'create.integrante' }
          // { title: 'Activar / Desactivar', icon: 'mdi-checkbox-blank-circle', color: 'grey darken-3', action: 'disableData', code: 'disable.espacio' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {},
    breadcrumb: [] // Inicializa el breadcrumb
  }),
  components: {
    DataTableMainServer,
    ViewDetails,
    Breadcrumb
  },
  mounted () {
    if (this.espacio && this.espacio.id) {
      this.fetchDeportes(this.espacio.id) // Llama a la función de obtención de deportes
    }
    const espacioId = this.$route.params.espacioId
    console.log(espacioId)
    // Obtener el breadcrumb de la ruta
    this.breadcrumb = this.$route.meta.breadcrumb || []

    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES', 'SHOW_DIALOG_REPORT', 'SHOW_DIALOG_ALERT_MAIN']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    fetchDeportes (espacioId) {
    // Realiza la llamada a la API usando el espacioId
      this.POSTPagination({
        url: this.get_urls['deportes.list-pagination'],
        data: { espacio_id: espacioId }
      })
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true // Muestra el estado de carga
      if (val) this.params = val // Actualiza params si se pasa un valor
      else this.params = this.default // Usa valores por defecto si no
      // Verifica que el espacio esté definido antes de usarlo
      if (!this.espacio) {
        console.error('El ID del espacio no está definido.')
        return // Sale si el ID del espacio no está disponible
      }
      // Asigna el espacioId usando el valor recibido como prop
      this.params.espacioId = this.espacio
      // Ejecuta la URL para obtener la paginación
      this.ExecuteUrl('deportes.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('deportes.list-pagination')
    },
    toLigas (item) {
      const deportesId = { id: item.item.id, nombre: item.item.descripcion } // Asegúrate de que este sea el campo correcto para el ID del espacio
      this.$emit('viewLigas', deportesId)
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('deportes.list-pagination')
    },
    newData (item) {
      const objectMain = {
        tipo_actividad_id: 2,
        empresa_id: this.user.empresa_id,
        espacio_id: this.espacio.id
      }
      console.log('objectMain:', objectMain)
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Nuevo Deporte',
        body: {
          objectMain: { tipo_actividad_id: 2, empresa_id: this.user.empresa_id, espacio_id: this.espacio.id, user: this.user.usuario_id },
          paramsDialog: {
            url: this.get_urls['deportes.execute'],
            urloption: this.get_urls['deportes.options'],
            process: 1,
            actividad: 2,
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    toUpdate (item) {
      console.log('Datos antes:', item)
      console.log('Responsable:', item.item.descripcion)
      const data = {
        id: item.item.id,
        user: this.user.usuario_id,
        deporte_id: item.item.descripcion.deporte_id,
        deporte: item.item.descripcion.deporte,
        espacio_id: item.item.descripcion.espacio_id,
        tipo_actividad_id: item.item.descripcion.tipo_actividad_id,
        responsable: item.item.descripcion.responsable.id || '', // ID del responsable seleccionado
        responsableD: {
          id: item.item.descripcion.responsable.id || '', // ID del responsable
          NombreCompleto: item.item.descripcion.responsable.NombreCompleto || '' // Nombre visible del responsable
        }
      }
      console.log('Datos a enviar para actualización:', data)
      this.SHOW_DIALOG_MAIN({
        type: 'update',
        form: 'process',
        with: '60%',
        title: 'Editar Deporte',
        body: {
          objectMain: data,
          paramsDialog: {
            urloption: this.get_urls['deportes.options'],
            url: this.get_urls['deportes.execute'],
            process: 1,
            message: 'Registro Actualizado Correctamente',
            updated: true,
            setmodel: true
          }
        }
      })
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Deporte`,
        body: {
          objectMain: item,
          url: this.get_urls['deportes.up-down'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    newEncargado (item) {
      console.log('empleado', this.user.empleado_id)
      const data = {
        empleado_id: this.user.empleado_id,
        item: item
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: 680,
        title: 'Nuevo Empleado',
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_EmpleadoForm,
            url: this.get_urls['empresa.empleados.create'],
            message: 'Registro Agregado Correctamente',
            updated: true,
            returnObject: true,
            setmodel: true
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objectPagination', 'get_objects', 'get_InventariosEquiposFilterForm', 'get_TicketsUuAaForm', 'get_ReporteGeneralInventariablesForm', 'get_EmpleadoForm']),
    object () {
      return this.table.modelMain.length > 0 ? this.table.modelMain[0] : {}
    }
  },
  watch: {
    espacio: {
      immediate: true,
      handler (newEspacio) {
        if (newEspacio && newEspacio.id) {
          this.fetchDeportes(newEspacio.id)
        }
      }
    },
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') {
        this.refreshData({})
      }
      this.SEND_DATA_VIEW({})
    }
  }
}
</script>

<style scoped>
</style>
